import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'react-i18next';
import { locales } from './locales';

interface Props {}

export const CurrentLanguage = (props: Props) => {
    const { locale } = useRouter();
    const { t } = useTranslation('common');

    return (
        <small className="tw-text-accents-7">
            <Trans ns="common">Die aktuell gewählte Sprache ist</Trans>
            {': '}
            {locales[locale]?.label || t('Unbekannt')}
        </small>
    );
};
